import { NOOP } from "@shared";
import { scheduleUndo } from "./undo";
export const notEq = (_a, _b) => false;
export function modifyWritable(fn, store, dedupeId, timeout) {
    let undo = NOOP;
    store.update((data) => {
        undo = fn(data);
        return data;
    });
    return scheduleUndo(() => {
        store.update((s) => {
            undo();
            return s;
        });
    }, dedupeId, timeout);
}
export function removeFromWritableLocalMap(key, store, timeout) {
    return modifyWritable((d) => d.remove(key), store, undefined, timeout);
}
export function addToWritableLocalMap(key, val, store, timeout) {
    return modifyWritable((d) => d.addOrUpdate(key, val), store, undefined, timeout);
}
export function addToWritableLocalSet(val, store, timeout) {
    return modifyWritable((d) => d.add(val), store, undefined, timeout);
}
export function removeFromWritableLocalSet(val, store, timeout) {
    return modifyWritable((d) => d.remove(val), store, undefined, timeout);
}
export function addToWritableMap(key, val, store, timeout) {
    return modifyWritable((d) => {
        d.set(key, val);
        return () => d.delete(key);
    }, store, undefined, timeout);
}
export function modifyWritableMap(key, fn, store, notFound, dedupeId, timeout, isEmpty) {
    return modifyWritable((d) => {
        let state = d.get(key);
        if (state === undefined) {
            state = notFound();
            d.set(key, state);
        }
        const undo = fn(state);
        return () => {
            const restored = undo(state);
            // drop entries that no longer carry any update so that consumers don't keep
            // paying to apply them
            if (isEmpty?.(restored)) {
                d.delete(key);
            }
            else {
                d.set(key, restored);
            }
        };
    }, store, dedupeId, timeout);
}
export function removeFromWritableMap(key, store, timeout) {
    return modifyWritable((d) => {
        const prev = d.get(key);
        if (prev === undefined)
            return NOOP;
        d.delete(key);
        return () => {
            if (prev !== undefined) {
                d.set(key, prev);
            }
        };
    }, store, undefined, timeout);
}
